import React, { useEffect } from "react";
import { Alert, Col, Container, Row } from "reactstrap";

import Header from "./Header";
import MainDetails from "./MainDetails";
import AdditionalDetails from "./AdditionalDetails";
import { useParams, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { getUSSanctionedItem as onGetUSSanctionedItem } from "../../../../slices/thunks";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewUSSanctionedItem = () => {
  const location = useLocation();
  const dispatch: any = useDispatch();

  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View US Sanctions List", itemId);

  useEffect(() => {
    dispatch(onGetUSSanctionedItem(itemId));
  }, [itemId, dispatch]);

  const selectLayoutState = (state: any) => state.SanctionsList;
  const selectProperties = createSelector(selectLayoutState, (state) => ({
    usSanctionedItem: state.usSanctionedItem,
  }));

  const { usSanctionedItem } = useSelector(selectProperties);

  document.title = "US Sanctioned Item | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="US Sanction Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "US Sanctions List", link: "/sanctions-list/us" },
            ]}
            back
          />
          <Row>
            <Col>
              <Alert color="danger" className="material-shadow">
                <strong> US Sanctions List! </strong> This entity has been
                sanctioned by the US. Please check the profile below for more
                information.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Header data={usSanctionedItem} />
          </Row>
          <Row>
            <MainDetails data={usSanctionedItem} />
            <AdditionalDetails data={usSanctionedItem} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewUSSanctionedItem;
